import { Component, Input, OnInit } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import moment from 'moment';

import {
  IProductType,
} from '@cakeiteasy/web-utils';


@Component({
  standalone: false,
  selector: 'product-sold-out-dates-info',
  template: `
    <div [innerHTML]="message"></div>
  `,
})
export class ProductSoldOutDatesInfoComponent implements OnInit {
  @Input() productType: IProductType;

  public message = '';

  constructor(private _translate: TranslateService) {
  }

  ngOnInit() {
    this.message = this._getMessage();
  }

  private _getMessage(): string {
    const dates = this.productType.stockSettings.soldOutDates
      .map(date => moment(date, 'YYYY-MM-DD', true))
      .filter(date => date.isValid())
      .map(date => date.format('dddd D. MMMM'))
      .join(', ');

    if (!dates) {
      return '';
    }

    return this._translate.instant(
      'cakeBuilder.productInfo.soldOutDates',
      { dates },
    );
  }
}
